import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const propertyPriceTracking = {
    hitOfferDetailViewPriceAB: () => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "page_view",
            event_category: "widok inwestycji"
        });
    },
    hitPropertyDetailViewPriceAB: () => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "page_view",
            event_category: "widok nieruchomości"
        });
    },
    hitLeadSentPriceAB: (hasPrice: boolean) => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "property_form_send",
            has_price: hasPrice ? "true" : "false"
        });
    }
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

export const propertyPriceTracking = {
    hitOfferDetailViewPriceAB: () => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "page_view",
            event_category: "widok inwestycji"
        });
    },
    hitPropertyDetailViewPriceAB: () => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "page_view",
            event_category: "widok nieruchomości"
        });
    },
    hitLeadSentPriceAB: (hasPrice: boolean) => {
        hitGoogleTagManager({
            event: "test_price_reveal",
            event_action: "property_form_send",
            has_price: hasPrice ? "true" : "false"
        });
    }
};
